
export default [

  {
    path: '/mine/nnkp', // 诺诺开票
    name: 'Nnkp',
    component: () => import('@/view/mine/child/Nnkp')
  },
  /** 临停缴费 */
  {
    path: '/kongData',
    name: 'KongData',
    component: () => import('@/view/Kong')
  },

  /** 无牌车入场 */
  {
    path: '/temporary/index',
    name: 'TemporaryIndex',
    component: () => import('@/view/temporary/Index')
  },
  {
    path: '/temporary/enter',
    name: 'EnterSuccess',
    component: () => import('@/view/temporary/EnterSuccess')
  },
  /** 停车场 */
  {
    path: '/parking/index',
    name: 'Parking',
    component: () => import('@/view/parking/Index')
  },
  {
    path: '/parking/navigate/:site',
    name: 'Navigation',
    component: () => import('@/view/parking/Navigation')
  },
  /** 添加车辆/手动缴费入口 */
  {
    path: '/hotel',
    name: 'Hotel',
    component: () => import('@/view/addCar/Hotel')
  },

  {
    path: '/hotelCar',
    name: 'HotelCar',
    component: () => import('@/view/hotelCar/Index')
  },
  {    path: '/hotelCar/seleckPark',  // 选择停车场
    name: 'HotelSelectPark',
    component: () => import('@/components/common/SelectPark.vue'),
    props: { payType: 'stored' } // 酒店车默认使用储值类型的处理逻辑
  },

  {    path: '/hotelCar/selectPark',  // 选择停车场
    name: 'SelectPark',
    component: () => import('@/components/common/SelectPark.vue'),
    props: { payType: 'stored' } // 酒店车默认使用储值类型的处理逻辑
  },

  {
    path: '/subscribe', // 订阅车场管理
    name: 'Subscribe',
    component: () => import('@/view/mine/Subscribe')
  },
  /* 二级 */
  {
    path: '/car/edit/:id', // 编辑车辆
    name: 'EditCar',
    component: () => import('@/view/mine/child/EditCar')
  },
  {
    path: '/car/authorizeNoSense/:carNo', // 微信无感支付授权
    name: 'AuthorizeNoSense',
    component: () => import('@/view/mine/child/AuthorizeNoSense')
  },

  { // 领取优惠券页面
    path: '/getCoupon',
    name: 'getCoupon',
    component: () => import('@/view/GetCoupon')
  },
  { // 领取优惠券页面
    path: '/discountCode',
    name: 'DiscountCode',
    component: () => import('@/view/DiscountCode')
  },
  { // 领取优惠券页面
    path: '/fixedDiscountCode',
    name: 'FixedDiscountCode',
    component: () => import('@/view/FixedDiscountCode')
  }
]



// WEBPACK FOOTER //
// ./src/router/park.js